import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IJob } from 'src/types/client/clients';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-client-jobs',
  templateUrl: './client-jobs.component.html',
  styleUrls: ['./client-jobs.component.css']
})
export class ClientJobsComponent implements OnInit {
  @Input() clientID: string = '';
  @Input() clientCorporation: string = '';
  jobDetails: IJob[] = [];
  displayLoader: boolean = true;
  showJobDetails: boolean = false;
  selectedJob: IJob | null = null;
  selectedJobId: number | null = null;
  mandatoryFiles: any[] = [];
  isComplianceLoading: boolean = false;
  mandatoryFileTypes = [
    'Position Description',
    'Risk Assessment',
    'Work Instruction / SOP',
    'Training'
  ];

  constructor(private http: HttpClient) { }

  ngOnInit(): void {
    this.clientJobDetails();
  }

  clientJobDetails() {
    const url = `${environment.apiConfig.uri}/admin/AdminClientContact/ClientJobDetails?clientId=${this.clientID}`;
    this.http.get(url, {}).subscribe(
      (response: any) => {
        this.jobDetails = response.data;
        this.displayLoader = false;
      },
      (error) => {
        console.error('Error fetching client job details:', error);
        this.displayLoader = false;
      }
    );
  }

  getMandatoryFiles(jobId: number) {
    const url = `${environment.apiConfig.uri}/admin/AdminClientContact/GetClientFiles?JobOrder=${jobId}`;
    this.http.get(url).pipe(
      finalize(() => {
        this.isComplianceLoading = false;
      })
    ).subscribe(
      (response: any) => {
        this.mandatoryFiles = response.data.MandatoryFiles || [];
      },
      (error) => {
        console.error('Error fetching mandatory files:', error);
        this.mandatoryFiles = [];
      }
    );
  }

  hasFileForType(fileType: string): boolean {
    return this.mandatoryFiles.some(file => file.type == fileType);
  }

  getFileNameForType(fileType: string): string {
    const file = this.mandatoryFiles.find(f => f.type == fileType);
    return file ? file.fileName : '';
  }

  onJobTitleClick(job: IJob) {
    this.selectedJob = job;
    this.selectedJobId = job.id;
    this.showJobDetails = true;
    this.isComplianceLoading = true;
    this.mandatoryFiles = [];
    this.getMandatoryFiles(job.id);
  }

  onJobSelectionChange() {
    if (this.selectedJobId) {
      this.isComplianceLoading = true;
      this.mandatoryFiles = [];
      this.selectedJob = this.jobDetails.find(job => job.id === this.selectedJobId) || null;
      if (this.selectedJob) {
        this.getMandatoryFiles(this.selectedJob.id);
      } else {
        this.isComplianceLoading = false;
      }
    }
  }

  backToJobList() {
    this.showJobDetails = false;
    this.selectedJob = null;
    this.selectedJobId = null;
    this.mandatoryFiles = [];
  }
}
""
